import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedStudies: [],
    studyPageFilters: {
        // productCategory: [],
        country: [],
        unileverBrand: [],
        deodorantFormat: [],
        studyPeriod: [],
    },
    studyPageSelectAllFilters: {
        // productCategory: false,
        country: false,
        unileverBrand: false,
        deodorantFormat: false,
        studyPeriod: false,
    },
    searchBarText: "",
    ulProductChecked: false,
    compProductChecked: false,
    unileverProductMetaDataFilters: {},
    filteredCoreDataIdsFromSearchFilters: null,
    productTestCodeMap: {},
    listedStudies: [],
    navigationAvailability: {},
    studyFiltersFlag: true,
    selectAllStudyFiltersFlag: false,
    sampleSizeWarningFlag: false,
};

export const studyDataStore = createSlice({
    name: "studyDataStore",
    initialState,
    reducers: {
        loadSelectedStudiesState: (state, action) => {
            state.selectedStudies = action.payload;
        },
        loadStudyPageFiltersState: (state, action) => {
            state.studyPageFilters = action.payload;
        },
        loadStudyPageSelectAllFiltersState: (state, action) => {
            state.studyPageSelectAllFilters = action.payload;
        },
        loadSearchBarTextState: (state, action) => {
            state.searchBarText = action.payload;
        },
        loadUlProductCheckedState: (state, action) => {
            state.ulProductChecked = action.payload;
        },
        loadCompProductCheckedState: (state, action) => {
            state.compProductChecked = action.payload;
        },
        loadUnileverProductMetaDataFiltersState: (state, action) => {
            state.unileverProductMetaDataFilters = action.payload;
        },
        loadFilteredCoreDataIdsFromSearchFiltersState: (state, action) => {
            state.filteredCoreDataIdsFromSearchFilters = action.payload;
        },
        loadProductTestCodeMapState: (state, action) => {
            state.productTestCodeMap = action.payload;
        },
        loadListedStudiesState: (state, action) => {
            state.listedStudies = action.payload;
        },
        loadNavigationAvailabilityState: (state, action) => {
            state.navigationAvailability = action.payload;
        },
        loadStudyFiltersFlagState: (state, action) => {
            state.studyFiltersFlag = action.payload;
        },
        loadSelectAllStudyFiltersFlagState: (state, action) => {
            state.selectAllStudyFiltersFlag = action.payload;
        },
        loadSampleSizeWarningFlag: (state, action) => {
            state.sampleSizeWarningFlag = action.Payload;
        },
        resetStudyDataStoreState: () => initialState,
    },
});

export const {
    loadSelectedStudiesState,
    loadStudyPageFiltersState,
    loadStudyPageSelectAllFiltersState,
    loadSearchBarTextState,
    loadUlProductCheckedState,
    loadCompProductCheckedState,
    loadUnileverProductMetaDataFiltersState,
    loadFilteredCoreDataIdsFromSearchFiltersState,
    loadProductTestCodeMapState,
    loadListedStudiesState,
    loadNavigationAvailabilityState,
    loadStudyFiltersFlagState,
    loadSelectAllStudyFiltersFlagState,
    loadSampleSizeWarningFlag,
    resetStudyDataStoreState,
} = studyDataStore.actions;

export default studyDataStore.reducer;
